import React from "react";
import { Dialog } from "./Dialog";
import { css } from "aphrodite-jss";
import { styles } from "./AwardDetailDialogStyle";
import { AwardListItem, AwardProjectItem } from "../../models/AwardListItem";
import millify from "millify";
import { ProposalParticipant } from "src/models/ProposalListItem";
import { Link } from "react-router-dom";

interface IAwardDetailDialogProps {
    isOpen: boolean;
    onClose: any;
    data: AwardListItem;
}

export class AwardDetailDialog extends React.Component<IAwardDetailDialogProps> {

    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
        data: new AwardListItem()
    };

    constructor(props: IAwardDetailDialogProps) {
        super(props);
    }

    public render() {
        return (            
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        <div id="content" className={css(styles.content)} >

                            <a id="title" target="_" className={css(styles.title)}  >
                                {this.props.data.title}
                            </a>

                            <div id="source" className={css(styles.source)}>
                                <div id="label">
                                    Sponsor:  
                                </div>
                                <div id="name" >
                                    {this.props.data.agency} 
                                </div>
                            </div>


                            <div id="date" className={css(styles.date)}>
                                <div id="label" >
                                    Begin Date: 
                                </div>
                                <div id="name" >
                                    {this.props.data.begin_date} 
                                </div>
                            </div>

                            <div id="date" className={css(styles.date)}>
                                <div id="label" >
                                    End Date: 
                                </div>
                                <div id="name" >
                                    {this.props.data.end_date} 
                                </div>
                            </div>

                            <div id="abstrat" className={css(styles.abstract)}  >
                                <div id="label" >
                                    Abstract
                                </div>
                                <div>
                                    {this.props.data.description}
                                </div>
                            </div>

                            <table id="projects" className={css(styles.projects)} >
                                    <tr>
                                        <th>ID</th>
                                        <th style={{whiteSpace: "nowrap"}}>Begin Year</th> 
                                        <th style={{whiteSpace: "nowrap"}}>End Year</th>
                                        <th>Budget</th>
                                        <th>Investigators</th>
                                    </tr>
                                    {this.buildProjectRow()}
                            </table>
                        </div>                       
                    </React.Fragment>
                </div>
            </Dialog>
        )
    }

    private buildProjectRow = () => {
        return this.props.data.projects.map((projectItem: AwardProjectItem, index: number)=> {
            return (
                <tr key={index} >
                    <td id="id" >
                        {projectItem.id}
                    </td>
                    <td id="begin_year" >
                        {projectItem.begin_date}
                    </td>
                    <td id="end_year" >
                        {projectItem.end_date}
                    </td>
                    <td id="budget" >
                        {"$"+ millify(+projectItem.budget)}
                    </td>
                    <td id="people" >
                        {this.buildPeople(projectItem.participants.slice(0,5))}
                    </td>
                </tr>
            )
        });
    }

    private buildPeople = (people: ProposalParticipant[]) => {
        return (
            <React.Fragment>
                {people.map((person: ProposalParticipant, index: number)=>{
                    return <Link to={`/faculty/${person.id}`} key={index} target="_blank">
                        {person.first_name + " " + person.last_name + ", "}
                    </Link>
                })}
            </React.Fragment>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dialogs/AwardDetailDialog.tsx